<ui-m060-c010-vehicle-showroom-header [headline]="headline()" [subheadline]="subheadline()" />

<div class="m060-c010 relative">
    <div class="relative z-10">
        <div class="relative block">
            @if (cars().length > 1) {
                <ui-m060-c010-vehicle-showroom-tabs
                    [tabs]="tabs()"
                    [currentIndex]="slider.currentIndex()"
                    (tabClicked)="slider.slideToIndex($event)"
                />
                <ui-m060-c010-vehicle-showroom-slider
                    #slider
                    [cars]="cars()"
                    [isFirstView]="isFirstView()"
                    (emitCurrentTabIndex)="changeCurrentTabIndex($event)"
                />
            } @else {
                <ui-m060-c010-vehicle-showroom-item
                    class="block overflow-x-hidden"
                    [car]="cars()[0]"
                    [isFirstView]="isFirstView()"
                    lastSlide
                />
            }
        </div>
    </div>
    <div class="bg-grey-500 absolute bottom-0 left-0 h-[40%] w-full md:h-[175px]"></div>
</div>

@if (cars()[currentTabIndex()] && cars()[currentTabIndex()].showroomButtons) {
    <ui-m060-c010-vehicle-showroom-buttons
        [data]="cars()[currentTabIndex()].showroomButtons"
        [primaryButton]="primaryButton()"
        [primaryButtonText]="primaryButtonText()"
        [envkv]="envkv()"
    />
}

@let car = cars()[currentTabIndex()];
@if (car.imageCaption || car.nationalPricesDisclaimer) {
    <div class="bg-grey-100">
        <div class="inner-page-wrapper flex flex-col gap-4 pb-4 lg:w-full lg:flex-row lg:justify-between">
            @if (car.imageCaption) {
                @let label = car.imageCaption | footnotes;
                <span class="text-14 text-grey-400 leading-21" [innerHTML]="label()"></span>
            }

            @if (car.nationalPricesDisclaimer && !car.individualData) {
                @let label = car.nationalPricesDisclaimer | footnotes;
                <span class="text-14 text-grey-400 leading-21" [innerHTML]="label()"></span>
            }
        </div>
    </div>
}
